<div *ngIf="commentsLoaded">
  <div *ngIf="comments else noComments" class="comments-container">
    <textarea rows="10" readonly class="textarea-container">{{ comments }}</textarea>
  </div>
  <ng-template #noComments>
    <p class="no-comments-container">No comments added.</p>
  </ng-template>
</div>